import { ReactElement } from 'react';

import { StyledHr } from './styles';
import { HrProps, HrWeight, HrWeightType } from './types';

const weightToHeight: Record<HrWeightType, number> = {
	[HrWeight.Normal]: 1,
	[HrWeight.Heavy]: 2,
};

const Hr = ({ weight = HrWeight.Normal, color = 'black', opacity = 1, className }: HrProps): ReactElement => {
	return (
		<StyledHr $height={weightToHeight[weight]} $color={color} $opacity={opacity} className={className} />
	);
};

export default Hr;
